import { createBrowserRouter, Outlet, useNavigation } from "react-router-dom";
import MainLayout from "../../Layouts/MainLayout";
import LoaderComponent from "../Common/LoaderComponent";
import { NoMatch } from "../Error/NoMatch";
import LegacyPathTokenRedirect from "./LegacyPathTokenRedirect";
import LegacyTokenPrefixRedirect from "./LegacyTokenPrefixRedirect";
import ObfuscatedRouteOutlet from "./ObfuscatedRouteOutlet";
import ProgressBar from "./ProgressBar";
import ProtectedRoute from "./ProtectedRoute";
import RedirectUnknown from "./RedirectUnknown";
import { getRouteTokenSegment } from "../../lib/routeTokens";
import { protectedAppRoutes } from "./protectedAppRoutes";
import lazyLoader from "./lazyLoader";

const Login = lazyLoader(() => import("../Auth/index"));
const SubscriptionLogin = lazyLoader(() =>
  import("../Subscription/SubscriptionModel/SubscriptionLogin")
);
const SubscriptionPreview = lazyLoader(() =>
  import("../Subscription/SubscriptionModel/SubscriptionPreview")
);
const UpdatePassword = lazyLoader(() =>
  import("../UpdatePassword/UpdatePassword")
);
const UpdateApiKey = lazyLoader(() =>
  import("../UpdateApiKey/UpdateApiKey")
);

const router = createBrowserRouter([
  {
    element: (
      <>
        <ProgressBar />
        <Outlet />
      </>
    ),
    errorElement: <NoMatch />,
    children: [
      {
        element: <ProtectedRoute role={"public"} />,
        errorElement: <NoMatch />,
        children: [
          {
            path: "/update-password",
            element: <UpdatePassword fullPage />,
          },
          {
            path: "/update-api-key",
            element: <UpdateApiKey fullPage />,
          },
          {
            path: "/websmpp/subscriber/login",
            element: <SubscriptionLogin />,
            errorElement: <NoMatch />,
          },
          {
            path: "/websmpp/subscriber/preview",
            element: <SubscriptionPreview />,
            errorElement: <NoMatch />,
          },
        ],
      },
      {
        element: <ProtectedRoute role={"guest"} />,
        errorElement: <NoMatch />,
        children: [
          {
            path: "/",
            element: <Login />,
            errorElement: <NoMatch />,
          },
          {
            path: "/login",
            element: <Login />,
            errorElement: <NoMatch />,
          },
        ],
      },
      {
        element: <MainLayout />,
        errorElement: <NoMatch />,
        children: protectedAppRoutes,
      },
      {
        path: "/*",
        element: <LegacyPathTokenRedirect />,
      },
      {
        path: "t/:routeToken",
        element: <LegacyTokenPrefixRedirect />,
      },
      {
        path: `${getRouteTokenSegment()}/:routeToken`,
        element: <MainLayout />,
        children: [{ index: true, element: <ObfuscatedRouteOutlet /> }],
      },
    ],
  },
  {
    path: "*",
    element: <RedirectUnknown />,
  },
]);
export default router;